// extracted by mini-css-extract-plugin
export var body = "_kl-0";
export var sectionHeader = "_kl-4";
export var shortcutColumns = "_kl-2";
export var shortcutList = "_kl-1";
export var shortcutSection = "_kl-3";